const ProductRouters = {
	monkeyTechEndpoint: () => `${Api.baseUrl}`,
	produtoList: () => `${ProductRouters.monkeyTechEndpoint()}/produtos/todos`,
	produtoById: (id) => `${ProductRouters.monkeyTechEndpoint()}/produtos/${id}`,
	createProduto: () => `${ProductRouters.monkeyTechEndpoint()}/produtos/novo`,
	updateProdutoById: (id) => `${ProductRouters.monkeyTechEndpoint()}/produtos/mudar/${id}`,
	deleteProdutoById: (id) => `${ProductRouters.monkeyTechEndpoint()}/produtos/del/${id}`,
	usuarioList: () => `${ProductRouters.monkeyTechEndpoint()}/usuarios`,
	usuarioById: (id) => `${ProductRouters.monkeyTechEndpoint()}/usuarios/${id}`,
	createUsuario: () => `${ProductRouters.monkeyTechEndpoint()}/usuarios/novo`,
	updateUsuarioById: (id) => `${ProductRouters.monkeyTechEndpoint()}/usuarios/mudar/${id}`,
	deleteUsuarioById: (id) => `${ProductRouters.monkeyTechEndpoint()}/usuarios/del/${id}`,
	login: () => `${ProductRouters.monkeyTechEndpoint()}/login`,
};
const Api = {
	baseUrl: 'https://monkeytechv2.herokuapp.com',
	...ProductRouters,
};
export default Api;
